import React from "react";
import {IoIosArrowForward} from "react-icons/io";
import {TbBrandGithubFilled} from "react-icons/tb";
import {Tags} from "./projectBits";
import trail from "../assets/projects/trailblazer/trail.jpg";
import rider from "../assets/projects/trailblazer/rider.jpg";
import pickups from "../assets/projects/trailblazer/pickups.jpg";
import campus from "../assets/projects/trailblazer/campus.jpg";
import ownPath from "../assets/projects/trailblazer/own-path.jpg";
import kit from "../assets/projects/trailblazer/kit.jpg";
import backToStart from "../assets/projects/trailblazer/back-to-start.jpg";

const REPO = "https://github.com/nour2063/trailblazer";
const APK = `${REPO}/releases/download/v1.0.0/Trailblazer.apk`;

const GALLERY = [
    {src: rider, title: "Riding with the trail", caption: "Passthrough lets you see the real square around you."},
    {src: pickups, title: "Collect coins and power-ups", caption: "Floating pickups placed around the course."},
    {src: campus, title: "Playtesting on campus", caption: "Out in the open, away from traffic."},
    {src: ownPath, title: "Don't cross your own path", caption: "Your trail stays where you rode it."},
    {src: kit, title: "The kit", caption: "A Quest 3, a bike, and a wide open space."},
    {src: backToStart, title: "Back to the start", caption: "Return to the start area to play again."},
];

export function TrailblazerPage() {
    return (
        <div className="pj-page">
            <img className="pj-banner tb-banner" src={trail} alt="A glowing trail and floating coins over a paved square, seen through the headset"/>
            <div className="pj-page-head">
                <div>
                    <h2>Trailblazer</h2>
                    <p className="pj-muted">Gamified mixed reality cycling</p>
                </div>
                <Tags tags={["Unity", "Quest 3"]}/>
            </div>
            <hr/>
            <p>
                An exploration of interactions and visuals in mixed reality for cycling. Inspired by Snake and Tron, Trailblazer turns any open space into a game: as you ride, a glowing trail follows you through {"pass\u00ADthrough"}, and the course fills with things to chase.
            </p>
            <div className="pj-info-card">
                <h4>How to play</h4>
                <ul className="pj-points">
                    <li>Collect coins and power-ups to raise your score</li>
                    <li>Avoid the trail drawn by your own path</li>
                    <li>Hit your trail and lose 20 points</li>
                </ul>
            </div>

            <h3>Try it out</h3>
            <hr/>
            <div className="pj-info-cards tb-try">
                <div className="pj-info-card">
                    <h4>Meta Quest 3</h4>
                    <ol>
                        <li>Enable developer mode and sideload the APK (e.g. with SideQuest)</li>
                        <li>Launch it with spatial features on and draw a very large boundary in a wide open space</li>
                        <li>Turn spatial features off with the app still open, so the boundary doesn't stop you</li>
                    </ol>
                    <p className="pj-small pj-muted">A conceptual demo, provided as is with no warranty. Riding with a headset on is not supported by Meta, so ride at your own risk.</p>
                    <a className="button pj-act" href={APK}>Download the APK <IoIosArrowForward/></a>
                </div>
                <div className="pj-info-card">
                    <h4>Source</h4>
                    <p>Built in Unity. Clone the repo and open <code>BikeScene</code>.</p>
                    <a className="button pj-act tb-source" href={REPO} target="_blank" rel="noopener noreferrer">
                        <TbBrandGithubFilled/> Source on GitHub
                    </a>
                </div>
            </div>

            <h3>Gallery</h3>
            <hr/>
            <div className="pj-gallery">
                {GALLERY.map(g => (
                    <figure key={g.title}>
                        <img src={g.src} alt={g.title} loading="lazy"/>
                        <figcaption><b>{g.title}</b><span className="pj-muted">{g.caption}</span></figcaption>
                    </figure>
                ))}
            </div>
        </div>
    );
}
